import React, { useState } from 'react';
import MyChartPing from '../../../../../app/modules/custom/Graphics/CHARTPINS/chartping_heathcheck';
import './CustomModalHeathCheck.css';

interface CustomModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: (startDate: string, endDate: string, limit: number) => void;
  title: string;
  children: React.ReactNode;
  chartData: number[];
  chartPlot: string[];
  additionalData: any[];
  chartTitle: string;
  chartSubtitle: string;
  yAxisTitle: string;
  selectedCell: string;
  selectedProcess: string | null;  // Proceso seleccionado
  setSelectedProcess: (process: string) => void;
  setChartData: (data: number[]) => void;
  setChartPlot: (plot: string[]) => void;
}

const CustomModal: React.FC<CustomModalProps> = ({
  show,
  handleClose,
  handleConfirm,
  title,
  children,
  chartData,
  chartPlot,
  additionalData,
  chartTitle,
  chartSubtitle,
  yAxisTitle,
  selectedCell,
  selectedProcess,
  setSelectedProcess,
  setChartData,
  setChartPlot
}) => {
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString().split('T')[0]
  );
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [limit, setLimit] = useState(5);

  if (!show) {
    return null;
  }

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <div className="custom-modal-header">
          <h4>{title}</h4>
          <button onClick={handleClose} className="close-button">&times;</button>
        </div>
        <div className="custom-modal-body">
          {children}
          <div className="row">
            <div className="col">
              <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="startDate">Start date</label>
              <input
                type="date"
                required
                className='form-control form-control-solid border-gray-300 f-parrafo'
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col">
              <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="endDate">End date</label>
              <input
                type="date"
                required
                className='form-control form-control-solid border-gray-300 f-parrafo'
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            {/* Dropdown para seleccionar el proceso */}
            {selectedCell === 'Process Status' && (
              <div className="col">
                <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="processSelect">Select Process:</label>
                <select
                  id="processSelect"
                  className='form-control form-control-solid border-gray-300 f-parrafo'
                  value={selectedProcess || ''}
                  onChange={(e) => {
                    setSelectedProcess(e.target.value);  // Cambiar el proceso seleccionado
                    setChartData([]);  // Limpiar datos de la gráfica
                    setChartPlot([]);  // Limpiar etiquetas de la gráfica
                  }}
                >
                  <option value="">-- Select Process --</option>
                  {['process_bgp', 'process_sync', 'process_ha1', 'process_ha2'].map((process) => (
                    <option key={process} value={process}>
                      {process}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="col">
              <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="limit">Limit:</label>
              <div className="d-flex">
                <select
                  id="limit"
                  className='form-control form-control-solid border-gray-300 f-parrafo me-2'
                  value={limit}
                  onChange={(e) => setLimit(parseInt(e.target.value))}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
                <button onClick={() => handleConfirm(startDate, endDate, limit)} className="btn-light-marino f-parrafo">Search</button>
              </div>
            </div>
          </div>

          {chartData && chartPlot && (
            <div className="chart-container mt-4">
              <MyChartPing
                chartId="custom-modal-chart"
                plot={chartPlot}
                data={chartData}
                additionalData={additionalData}
                title={chartTitle}
                subtitle={chartSubtitle}
                yAxisTitle={yAxisTitle}
                selectedCell={selectedCell}
              />
            </div>
          )}
        </div>
        <div className="custom-modal-footer">
          <button onClick={handleClose} className="btn-cancel btn border border-pink text-pink f-parrafo">Close</button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;